<div
    class="anc-language-selector"
    ngbDropdown
    display="dynamic"
    placement="bottom-end"
    [popperOptions]="popperOptions"
    autoClose="outside"
    (openChange)="onDropdownOpenChange($event)"
>
    <button
        type="button"
        class="anc-language-selector__pill anc-fc-pill"
        [class.anc-fc-pill--size-default]="size() === 'default'"
        [class.anc-fc-pill--size-compact]="size() === 'compact'"
        [class.anc-fc-pill--size-mini]="size() === 'mini'"
        [class.anc-fc-pill--open]="menuOpen"
        [attr.aria-label]="'Language: ' + displayAbbreviation()"
        ngbDropdownToggle
    >
        <span class="anc-fc-icon anc-language-selector__icon" aria-hidden="true">
            @if (iconSrc()) {
                <img
                    class="anc-language-selector__icon-img"
                    [src]="iconSrc()"
                    alt=""
                />
            } @else {
                <svg
                    class="anc-language-selector__icon-svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 6.66667L4.33333 2L6.66667 6.66667"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2.66666 5.33337H5.99999"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M13.3333 9.33337C13.2222 10.4445 12.3333 13 9.33331 14"
                        stroke="currentColor"
                        stroke-linecap="round"
                    />
                    <path
                        d="M13.3333 14C11.6666 13.6667 10.6666 12.6667 9.99998 11.3334"
                        stroke="currentColor"
                        stroke-linecap="round"
                    />
                    <path
                        d="M8.66666 9.33337L14 9.33337"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M11.3333 8L11.3333 9.33333"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M3.33334 9L3.33334 9.88889C3.33334 10.9935 4.22877 11.8889 5.33334 11.8889L7.33334 11.8889M6.16668 10.7778L7.33334 11.8889L6.16668 13"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M12.6667 6.66663L12.6667 5.77774C12.6667 4.67317 11.7712 3.77774 10.6667 3.77774L8.66666 3.77774M9.83332 4.88885L8.66666 3.77774L9.83332 2.66663"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            }
        </span>
        <span class="anc-fc-label anc-language-selector__abbreviation">{{
            displayAbbreviation()
        }}</span>
        <span class="anc-fc-caret icon icon-chevron-down" aria-hidden="true"></span>
    </button>

    <div ngbDropdownMenu class="anc-language-selector__menu" role="listbox">
        @for (language of languages(); track language.id) {
            <button
                type="button"
                class="dropdown-item"
                role="option"
                [attr.aria-selected]="resolvedSelectedKey() === language.option_key"
                (click)="onSelect(language)"
            >
                <span>{{ language.display }}</span>
            </button>
        }
    </div>
</div>
